var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/task/task-check",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(7.000000, 4.000000)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.313,11.26 L7.721,16.852 C7.5675478,17.005764 7.35923474,17.0921739 7.142,17.0921739 C6.92476526,17.0921739 6.7164522,17.005764 6.563,16.852 L4.688,14.976",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75,4.51 L16.5,4.51 C17.3284271,4.51 18,5.18157288 18,6.01 L18,21.76 C18,22.5884271 17.3284271,23.26 16.5,23.26 L1.5,23.26 C0.671572875,23.26 0,22.5884271 0,21.76 L0,6.01 C0,5.18157288 0.671572875,4.51 1.5,4.51 L5.25,4.51 C5.25,2.43893219 6.92893219,0.76 9,0.76 C11.0710678,0.76 12.75,2.43893219 12.75,4.51 Z",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.057,3.765 C9.20689475,3.78823655 9.32802908,3.89948594 9.36391084,4.04686597 C9.3997926,4.194246 9.34335434,4.34872796 9.22091658,4.43826772 C9.09847883,4.52780748 8.93415751,4.53476885 8.80458546,4.45590533 C8.67501341,4.3770418 8.60571176,4.22788673 8.629,4.078 C8.66078939,3.87339859 8.85238764,3.73328118 9.057,3.765",
    id: "path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskCheck);
export default __webpack_public_path__ + "static/media/task-check.4acfcb2ef7fdbccc995b316650aa660b.svg";
export { ForwardRef as ReactComponent };